import React from 'react';

function Plane(props) {
  return (
    <svg width="19" height="20" viewBox="0 0 19 20" xmlns="http://www.w3.org/2000/svg" {...props} fill="none">
      <path
        d="M17.6409 4.94359L14.4909 7.90609L17.4909 16.1561L15.2409 18.4061L10.7597 11.8436L8.49094 13.9061V16.1561L6.24094 18.4061L4.90969 14.478L0.990936 13.1561L3.24094 10.9061H5.49094L7.74094 8.65609L0.990936 4.15609L3.24094 1.90609L11.4909 4.90609L14.4628 1.76547L14.3972 1.81234C14.8199 1.38966 15.3932 1.15219 15.9909 1.15219C16.5887 1.15219 17.162 1.38966 17.5847 1.81234C18.0074 2.23503 18.2448 2.80832 18.2448 3.40609C18.2448 4.00387 18.0074 4.57716 17.5847 4.99984L17.6409 4.94359Z"
        stroke="#3F3C43"
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  );
}

export default Plane;
